export function isApp() {
	let ua = navigator.userAgent;
	if (/TheCover/i.test(ua)) {
		return true;
	}
	return false;
}

export function getDeviceid() {
	var ua = navigator.userAgent;
	let step1 = ua.trim().split('(TheCover_');
	if(step1.length<2){
		return '';
	}else {
		return step1[1].split('_')[2].split(')')[0]
	}
}

export function cbgcAnalyze(config){
	var para = {
		name:'cio',
		sdkUrl: 'https://dcdn.thecover.cn/cio/cover-track-cio.js',
		applicationId: "rmt_cbgc",
		...config
	}

	var p = para.sdkUrl, n = para.name, w = window, d = document,a=para.activeId,ap=para.applicationId,an=para.activeName?para.activeName:"", s = 'script',x = null,y = null;;
	w[n] = w[n] || function(a) {return function() {(w[n]._q = w[n]._q || []).push([a, arguments]);}};
	if (!w[n]._t) {
		x = d.createElement(s), y = d.getElementsByTagName(s)[0];
		x.async = 1;
		x.src = p+'?aid='+a+'&appid='+ap+'&an='+an;
		w[n].para = para;
		y.parentNode.insertBefore(x, y);
	}
}